import{a as d}from"./chunk.DWL5QFAQ.js";import{a as n}from"./chunk.2AIXLGYE.js";import{a as e}from"./chunk.NFEB7TIJ.js";import{a as i}from"./chunk.XPINZPW5.js";import{a}from"./chunk.65JZXZ5X.js";import{a as s}from"./chunk.5456T7GL.js";import{a as h}from"./chunk.LWUQDFQZ.js";import{c}from"./chunk.NWIV65VP.js";import{html as l}from"lit";import{property as r,query as m,state as v}from"lit/decorators.js";import{classMap as p}from"lit/directives/class-map.js";import{ifDefined as k}from"lit/directives/if-defined.js";import{live as x}from"lit/directives/live.js";import{css as f}from"lit";var b=f`
  ${n}
  ${d}

  :host {
    --checkbox-size: var(--he-form-control-toggle-size);

    display: inline-block;
  }

  .checkbox {
    display: inline-flex;
    align-items: top;
    font-family: var(--he-form-control-font-family);
    font-size: var(--he-form-control-font-size);
    font-weight: var(--he-font-weight-normal);
    color: var(--he-form-control-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .checkbox__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--checkbox-size);
    height: var(--checkbox-size);
    border: solid 1px var(--he-form-control-toggle-border-color);
    border-radius: 2px;
    background-color: var(--he-form-control-background-color);
    color: var(--he-color-neutral-0);
  }

  .checkbox__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  .checkbox__control .checkbox__icon {
    display: inline-flex;
    width: var(--checkbox-size);
    height: var(--checkbox-size);
  }

  /* Scale down the size of the check mark to match Fluent */
  .checkbox--checked .checkbox__icon {
    width: calc(var(--checkbox-size) * 0.8);
    height: calc(var(--checkbox-size) * 0.8);
  }

  .checkbox__control,
  .checkbox__control svg {
    width: var(--checkbox-size) !important;
    height: var(--checkbox-size) !important;
  }

  .checkbox__control-label-wrapper {
    display: inline-flex;
    align-items: center;
  }

  /* Hover */
  .checkbox:not(.checkbox--checked):hover:not(.checkbox--disabled) .checkbox__control {
    background-color: var(--he-neutral-fill-stealth-hover);
  }

  /* Active */
  .checkbox:not(.checkbox--checked):active:not(.checkbox--disabled) .checkbox__control {
    background-color: var(--he-neutral-fill-stealth-active);
  }

  /* Focus */
  .checkbox:not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control-label-wrapper {
    outline: solid var(--he-focus-ring-width) var(--he-form-control-toggle-focus-ring-color);
    outline-offset: 1px;
  }

  /* Checked */
  .checkbox--checked .checkbox__control {
    border-color: var(--he-accent-fill-rest);
    background-color: var(--he-accent-fill-rest);
  }

  /* Checked + hover */
  .checkbox.checkbox--checked:hover:not(.checkbox--disabled) .checkbox__control {
    border-color: var(--he-accent-fill-hover);
    background-color: var(--he-accent-fill-hover);
  }

  /* Checked + active */
  .checkbox.checkbox--checked:active:not(.checkbox--disabled) .checkbox__control {
    border-color: var(--he-accent-fill-active);
    background-color: var(--he-accent-fill-active);
  }

  /* Indeterminate */
  .checkbox--indeterminate .checkbox__control {
    border-color: var(--he-accent-fill-rest);
    color: var(--he-accent-fill-rest);
    background-color: var(--he-color-neutral-0);
  }

  /* Indeterminate + hover */
  .checkbox.checkbox--indeterminate:hover:not(.checkbox--disabled) .checkbox__control {
    border-color: var(--he-accent-fill-hover);
    color: var(--he-accent-fill-hover);
    background-color: var(--he-color-neutral-0);
  }

  /* Indeterminate + active */
  .checkbox.checkbox--indeterminate:active:not(.checkbox--disabled) .checkbox__control {
    border-color: var(--he-accent-fill-active);
    color: var(--he-accent-fill-active);
    background-color: var(--he-color-neutral-0);
  }

  /* Disabled */
  .checkbox--disabled {
    cursor: not-allowed;
  }

  .checkbox--disabled .checkbox__label {
    color: var(--he-type-disabled);
  }

  .checkbox--disabled .checkbox__control {
    border-color: var(--he-form-control-disabled-background);
  }

  .checkbox--disabled.checkbox--checked .checkbox__control {
    background-color: var(--he-form-control-disabled-background);
  }

  .checkbox--disabled.checkbox--indeterminate .checkbox__control {
    border-color: var(--he-form-control-disabled-background);
    color: var(--he-form-control-disabled-background);
  }

  /* Label */
  .checkbox__label {
    color: var(--he-form-control-color);
    line-height: var(--checkbox-size);
    margin-inline-start: 0.5em;
    user-select: none;
  }

  :host([required]) .checkbox__label::after {
    content: var(--he-form-control-required-content);
    margin-inline-start: var(--he-form-control-required-content-offset);
  }

  /* Error states */
  .form-control--has-interaction.form-control--has-error .checkbox__control {
    border-color: var(--he-form-control-error-color) !important;
  }

  .form-control--has-interaction.form-control--has-error:not(.checkbox--disabled):focus-within .checkbox__control {
    outline: solid 1px var(--he-form-control-error-color) !important;
    outline-offset: -2px;
  }

  /* Checkbox group */
  :host(.he-checkbox-group__checkbox) {
    display: flex;
  }

  :host(.he-checkbox-group__checkbox:not(.he-checkbox-group__checkbox--last)) {
    margin-bottom: var(--he-spacing-x-small);
  }

  /* High contrast */
  @media screen and (forced-colors: active) {
    .checkbox__control,
    .checkbox:not(.checkbox--checked):hover:not(.checkbox--disabled) .checkbox__control {
      border-color: ${e.ButtonText};
      background: ${e.ButtonFace};
    }

    .checkbox__icon {
      fill: ${e.ButtonText};
    }

    /* Hover */
    .checkbox:hover:not(.checkbox--disabled) .checkbox__control {
      box-shadow: none;
      outline: ${e.ButtonText} solid 2px;
      outline-offset: -3px;
    }

    /* Checked */
    .checkbox--checked .checkbox__control,
    .checkbox.checkbox--checked:hover:not(.checkbox--disabled) .checkbox__control {
      border-color: ${e.HighlightText};
      background: ${e.Highlight};
    }

    .checkbox--checked .checkbox__icon {
      fill: ${e.HighlightText};
    }

    /* Indeterminate */
    .checkbox--indeterminate .checkbox__control,
    .checkbox.checkbox--indeterminate:hover:not(.checkbox--disabled) .checkbox__control {
      border-color: ${e.Highlight};
      background-color: ${e.HighlightText};
      color: ${e.Highlight};
    }

    /* Disabled */
    .checkbox--disabled {
      opacity: 1;
    }

    .checkbox--disabled .checkbox__control {
      border-color: ${e.GrayText};
      background-color: ${e.ButtonFace};
    }

    .checkbox--disabled .checkbox__label {
      color: ${e.GrayText};
    }

    .checkbox--disabled.checkbox--checked .checkbox__icon {
      fill: ${e.GrayText};
    }

    .checkbox--disabled.checkbox--indeterminate .checkbox__control {
      border-color: ${e.GrayText};
      background-color: ${e.ButtonFace};
      color: ${e.GrayText};
    }
  }
`;var o=class extends a{constructor(){super(...arguments);this.formSubmitController=new h(this,{value:t=>t.checked?t.value||"on":void 0,defaultValue:t=>t.defaultChecked,setValue:(t,u)=>t.checked=u});this.hasFocus=!1;this.disabled=!1;this.required=!1;this.checked=!1;this.indeterminate=!1;this.invalid=!1;this.defaultChecked=!1}firstUpdated(){this.invalid=!this.input.checkValidity()}click(){this.input.click()}focus(t){this.input.focus(t)}blur(){this.input.blur()}checkValidity(){return this.input.checkValidity()}get validationMessage(){return this.input.validationMessage}reportValidity(){return this.input.reportValidity()}setCustomValidity(t){this.input.setCustomValidity(t),this.invalid=!this.input.checkValidity()}handleClick(){this.checked=!this.checked,this.indeterminate=!1,this.emit("he-change")}handleBlur(){this.hasFocus=!1,this.emit("he-blur")}handleDisabledChange(){this.input.disabled=this.disabled,this.invalid=!this.input.checkValidity()}handleFocus(){this.hasFocus=!0,this.emit("he-focus")}handleStateChange(){this.invalid=!this.input.checkValidity()}render(){return l`
      <div part="form-control" class="form-control">
        <label
          part="base"
          class=${p({checkbox:!0,"checkbox--checked":this.checked,"checkbox--disabled":this.disabled,"checkbox--focused":this.hasFocus,"checkbox--indeterminate":this.indeterminate})}
        >
          <input
            class="checkbox__input"
            type="checkbox"
            name=${k(this.name)}
            value=${k(this.value)}
            .indeterminate=${x(this.indeterminate)}
            .checked=${x(this.checked)}
            .disabled=${this.disabled}
            .required=${this.required}
            aria-checked=${this.checked?"true":"false"}
            aria-describedby="error-text"
            @click=${this.handleClick}
            @blur=${this.handleBlur}
            @focus=${this.handleFocus}
          />

          <span part="control-label-wrapper" class="checkbox__control-label-wrapper">
            <span part="control" class="checkbox__control">
              ${this.checked?l`
                    <svg
                      part="checked-icon"
                      class="checkbox__icon checkbox__icon--checked"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 2048 2048"
                      fill="currentColor"
                    >
                      <path d="M1837 557L768 1627l-557-558 90-90 467 466 979-978 90 90z" />
                    </svg>
                  `:""}
              ${!this.checked&&this.indeterminate?l`
                    <svg
                      part="indeterminate-icon"
                      class="checkbox__icon checkbox__icon--indeterminate"
                      viewBox="0 0 20 20"
                    >
                      <rect fill="currentColor" x="5" y="5" width="10" height="10" rx="1" fill-rule="evenodd" />
                    </svg>
                  `:""}
            </span>

            <span part="label" class="checkbox__label">
              <slot></slot>
            </span>
          </span>
        </label>

        <div
          part="form-control-error-text"
          id="error-text"
          class="form-control__error-text"
          aria-live="assertive"
        ></div>
      </div>
    `}};o.styles=b,o.baseName="checkbox",o.reactEvents={onHeBlur:new CustomEvent("he-blur"),onHeChange:new CustomEvent("he-change"),onHeFocus:new CustomEvent("he-focus")},c([m('input[type="checkbox"]')],o.prototype,"input",2),c([v()],o.prototype,"hasFocus",2),c([r()],o.prototype,"name",2),c([r()],o.prototype,"value",2),c([r({type:Boolean,reflect:!0})],o.prototype,"disabled",2),c([r({type:Boolean,reflect:!0})],o.prototype,"required",2),c([r({type:Boolean,reflect:!0})],o.prototype,"checked",2),c([r({type:Boolean,reflect:!0})],o.prototype,"indeterminate",2),c([r({type:Boolean,reflect:!0})],o.prototype,"invalid",2),c([s("checked")],o.prototype,"defaultChecked",2),c([i("disabled",{waitUntilFirstUpdate:!0})],o.prototype,"handleDisabledChange",1),c([i("checked",{waitUntilFirstUpdate:!0}),i("indeterminate",{waitUntilFirstUpdate:!0})],o.prototype,"handleStateChange",1);var G=o;export{o as a,G as b};
